import { createFileRoute } from '@tanstack/react-router'
import { TemplatesBrowse } from '~/components/templates/templates-browse'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/templates/')({
  component: TemplatesBrowse,
})
